import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { VUE_APP_FINANCEIRO_API_URL } from "@/commons/config";

export class TaxaRegulacaoAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_FINANCEIRO_API_URL}/api/centralServicos`;
  }

  public listReceitas(body: {
    cpfCnpj: string;
    page: number;
    size: number;
    ascendingSort: boolean;
    sort: string[];
  }): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/receitaTaxaRegulacaoTransporte`,
      body
    );
  }

  public listReceitasSaneamento(body: {
    cpfCnpj: string;
    page: number;
    size: number;
    ascendingSort: boolean;
    sort: string[];
  }): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/receitaTaxaRegulacaoSaneamento`,
      body
    );
  }

  public baixarDae(
    cpfCnpj: string,
    ids: string[],
    date: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/dae-gerar-taxa-regulacao`,
      {
        cpfCnpj,
        ids,
        date,
      },
      { responseType: "blob" }
    );
  }
}
